import { NamedNode } from '../models.js';
export const createNameSpace = (nameSpace) => {
    return (term) => NamedNode.getOrCreate(nameSpace + term);
};
//# sourceMappingURL=NameSpace.js.map